(function(angular){
    'use strict';

    var recentsMasterCtl = function(
        $scope:any,
        $window:any,
        $timeout:any,
        $location:any) {

        var vm:any = this;

        $scope.gridControlContainer = {};
        var operationsSinceRefresh = 0;

        var gridControl:any;

        var unwatchGridControl = $scope.$watch('gridControl', function(){
            if ($scope.gridControlContainer.control){
                gridControl = $scope.gridControlContainer.control;
                gridControl.refresh();
                unwatchGridControl();
            }
        });

        // Setting table height. I think we'll do this another way
        // in the end.
        $scope.go = function(path:any){
            $location.path('/' + path);
        };

        var w = angular.element($window);

        $scope.getViewerHeight = function() {
            var grid = document.querySelector('#folder-grid');
            var top = 0;
            if(grid !== null && angular.isFunction(grid.getBoundingClientRect)){
                top = grid.getBoundingClientRect().top;
            }
            return w.height() - top - 75;
        };

        $scope.viewerHeight = $scope.getViewerHeight();

        $scope.$watch($scope.getViewerHeight, function(newValue:any) {
            $scope.viewerHeight = 'height: ' + newValue + 'px;';
        });

        w.bind('resize', function() {
            $scope.$apply();
        });

        $scope.$on('bmLanguageChangeSuccess', function(){
            vm._setupGrid();
        });

        var clearAlerts = function(){
            $scope.alerts = [];
        };

        //NOTE: Usually much more complicated, but this particular grid doesn't have any buttons
        vm._setupGrid = function(){
            clearAlerts();
        };

        function refresh() {
            gridControl.reloadGrid();
            operationsSinceRefresh = 0;
        }

        $scope.$on('dms-operation-complete', function(event: any, operationModel: any) {
            // Following similar logic from storage-master-controller to handle operations.
            var op = operationModel.type;
            if (op === 'move' || op === 'copy' || op === 'moveToRecycle') {
                operationsSinceRefresh++;
                if (operationsSinceRefresh >= 5) {
                    refresh();
                }
            }
        });

        $scope.$on('dms-operation-batch-complete', function() {
            if (operationsSinceRefresh > 0) {
                refresh();
            }
        });

        $scope.$on('dmsItemRenamed', refresh);

        //to inform main-controller.js to update page title when Recent Activity page is loaded
        $timeout(function() {
            $scope.$emit('pageTitleUpdate', {
                itemType: 'RecentsList'
            });
        });

    };

    recentsMasterCtl.$inject = [
        '$scope',
        '$window',
        '$timeout',
        '$location',
    ];

    angular.module('onvio.documents').controller('recentsMaster', recentsMasterCtl);

})((window as any).angular);
